import Recipe from 'records/Recipe';
import Base from 'records/Base';

import {
  RECIPE_ASYNC_ACTION_START,
  RECIPE_ASYNC_ACTION_ERROR,
  RECIPE_ASYNC_UPDATE_ACTION_SUCCESS,
  RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS,
  RECIPE_UPDATE_ACTION_SUCCESS,
  RECIPE_RESET_STATE,
  RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS,
  RECIPE_ASYNC_DELETE_ACTION_SUCCESS,
  RECIPE_ACTION_SUCCESS,
} from 'actions/recipe';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Recipe(),
});

const actionsMap = {
  [RECIPE_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [RECIPE_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RECIPE_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Recipe(action.data),
    });
  },
  [RECIPE_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new Base({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [RECIPE_ASYNC_ARCHIVE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [RECIPE_ASYNC_DELETE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [RECIPE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  // only merge selected attributes
  [RECIPE_ASYNC_PARTIAL_UPDATE_SUCCESS]: (state, action) => {
    const originalRecipe = state.data;
    const newRecipe = originalRecipe.merge({
      ...action.data,
    });
    return new Base({
      loading: false,
      errorMessage: null,
      data: newRecipe,
    });
  },
  [RECIPE_RESET_STATE]: () => {
    return initialState;
  },
};

export default function recipe(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
